import script from "./NoiQuyUserView.vue?vue&type=script&setup=true&lang=js"
export * from "./NoiQuyUserView.vue?vue&type=script&setup=true&lang=js"

import "./NoiQuyUserView.vue?vue&type=style&index=0&id=c5f38050&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c5f38050"]])

export default __exports__